import { Capacitor } from '@capacitor/core'

export class PlatformService {
  /**
   * Check if running on a native platform (iOS or Android)
   */
  static isNative(): boolean {
    return Capacitor.isNativePlatform()
  }

  /**
   * Check if running on web platform
   */
  static isWeb(): boolean {
    return Capacitor.getPlatform() === 'web'
  }

  /**
   * Check if running on iOS
   */
  static isIOS(): boolean {
    return Capacitor.getPlatform() === 'ios'
  }

  /**
   * Check if running on Android
   */
  static isAndroid(): boolean {
    return Capacitor.getPlatform() === 'android'
  }

  /**
   * Get the current platform name
   */
  static getPlatform(): string {
    return Capacitor.getPlatform()
  }

  /**
   * Safely execute a Capacitor plugin method with error handling
   */
  static async safePluginCall<T>(
    pluginMethod: () => Promise<T>,
    fallback?: T
  ): Promise<T | undefined> {
    if (!this.isNative()) {
      return fallback
    }

    try {
      return await pluginMethod()
    } catch (error) {
      console.warn('Capacitor plugin call failed:', error)
      return fallback
    }
  }

  /**
   * Check if a specific Capacitor plugin is available
   */
  static isPluginAvailable(pluginName: string): boolean {
    if (!this.isNative()) {
      return false
    }

    // Check if the plugin is registered
    try {
      // This is a basic check - in practice, you might want to test actual plugin methods
      return true
    } catch {
      return false
    }
  }
}

export default PlatformService 